import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";

import {
  getMatrixProfileType,
  getRouteMatrix,
  isWaveEditModeSelector,
  volumeDataSelector,
} from "../../reducers/matrixProfile/selectors";

import {
  LOCATIONS_PLAN_TYPE,
  OVERRIDES_PLAN_TYPE,
} from "../../consts/planTypes";

import { View } from "../View";
import OverridesSummaryPanel from "./SummaryPannels/OverridesSummaryPanel";
import LocationsSummaryPanel from "./SummaryPannels/LocationsSummaryPanel";
import DefaultSummaryPanel from "./SummaryPannels/DefaultSummaryPanel";
import VolumeSummaryPanel from "./SummaryPannels/VolumeSummaryPanel";
import WaveSummaryPanel from "./SummaryPannels/WaveSummaryPanel";

const useStyles = makeStyles(() => ({
  container: {
    margin: "0 15px",
    color: "white",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
  },
  title: {
    fontSize: "15px",
    marginRight: "5px",
  },
}));

export const DepotSummary = () => {
  const styles = useStyles();

  const planType = useSelector(getMatrixProfileType);
  const volumeData = useSelector(volumeDataSelector);
  const routeMatrixConfig = useSelector(getRouteMatrix);
  const isWaveEditMode = useSelector(isWaveEditModeSelector);

  const renderSummaryPanel = () => {
    if (!routeMatrixConfig) return null;
    else if (planType === OVERRIDES_PLAN_TYPE) return <OverridesSummaryPanel />;
    else if (planType === LOCATIONS_PLAN_TYPE) return <LocationsSummaryPanel />;
    else if (!volumeData) return <DefaultSummaryPanel />;
    else if (isWaveEditMode) return <WaveSummaryPanel />;
    else return <VolumeSummaryPanel />;
  };

  return (
    <View className={styles.container}>
      <Typography className={styles.title}>Depot summary</Typography>
      {renderSummaryPanel()}
    </View>
  );
};

export default DepotSummary;
